
import { Col, Form, Stack, InputGroup, Button } from "react-bootstrap";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { useState } from "react";
/**Password input component */
const PasswordInput = ({ formInfo, formFieldDisplay, fieldName, col }) => {

  //console.log("PasswordInput", formInfo, formFieldDisplay);
  const [showHidePWDFlag, setShowHidePWDFlag] = useState(false);

  const showHidePWD = () => {
    setShowHidePWDFlag(!showHidePWDFlag);
  }

  const dataObj = formInfo?.data[fieldName];
  const fieldObj = formFieldDisplay[fieldName];

  return (
    <Col lg={col}>
      <Form.Group className="mb-2 passwordInput" as={Col} controlId={fieldName}>
        <Form.Label className={fieldObj?.display.label ? "" : "invisible"}>{fieldObj?.display.label ? fieldObj?.display.label : fieldObj?.name}</Form.Label>
        <InputGroup>
          <Form.Control
            name={fieldName}
            type={showHidePWDFlag ? "text" : "password"}
            placeholder="Enter your password"
            value={dataObj.value}
            isInvalid={dataObj.validation.isInvalid}
            onChange={dataObj.onChange}
            ref={fieldObj?.InputRef}
            maxLength={24}
            autoComplete="new-password"
          />
          <Button
            id={"show_" + fieldName}
            onClick={showHidePWD}
            className="smallText"
          >
            {showHidePWDFlag ? "Hide" : "Show"}
          </Button>
          <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
            {dataObj.validation.errors.map((item, index) =>
              <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                <div>{item}</div>
              </Stack>)}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </Col>
  )

}

export default PasswordInput;